// extracted by mini-css-extract-plugin
export default {"image":"h8XDtY"};